import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";

import "core-js/stable";
import "regenerator-runtime/runtime";
import "./assets/favicons";

import App from "./App";
import configureStore from "./configureStore";

import "normalize.css";
import "./index.global.css";

require("../scripts/svgLoader");

const store = configureStore();

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

export default store;
